<template>
  <v-container id="panels" fluid tag="section" class="dash-page">
    <!-- Background sama dengan login -->
    <div class="dash-bg" aria-hidden="true">
      <div class="dash-gradient"></div>
      <div class="dash-pattern"></div>
    </div>

    <v-row>
      <v-col class="mx-auto" cols="12" md="12">
        <base-material-tabs
          v-model="tab"
          color="warning"
          icons-and-text
          background-color="transparent"
        >
          <v-tab v-for="(t, i) in tabs" :key="i">
            {{ t.text }}
            <v-icon v-text="t.icon" />
          </v-tab>

          <v-tabs-items v-model="tab" class="pt-10 transparent">
            <!-- TAB 1: DATA -->
            <v-tab-item>
              <base-material-card
                icon="mdi-clipboard-text"
                title="List Data Laporan Pekerjaan"
                class="px-5 py-3 card-soft"
              >
                <br>
                <v-row class="align-center">
                  <v-col cols="12" sm="5" md="4">
                    <v-dialog
                      ref="SelMonth"
                      v-model="menuSelMonth"
                      :return-value.sync="selectedMonth"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="selectedMonth"
                          label="Pilih Bulan/Tahun"
                          prepend-inner-icon="mdi-calendar"
                          outlined
                          dense
                          readonly
                          v-on="on"
                          class="field"
                        />
                      </template>

                      <v-date-picker v-model="selectedMonth" type="month" scrollable>
                        <v-spacer />
                        <v-btn text color="primary" @click="menuSelMonth = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.SelMonth.save(selectedMonth)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col cols="12" sm="3" md="2">
                    <v-btn class="btn-secondary" block rounded @click="feedingTable()">
                      <v-icon left>mdi-refresh</v-icon>
                      Show Data
                    </v-btn>
                  </v-col>

                  <v-col cols="12" sm="4" md="6" class="text-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="btn-primary" rounded v-on="on" @click="showAddForm()">
                          <v-icon left>mdi-plus</v-icon>
                          Buat Laporan
                        </v-btn>
                      </template>
                      <span>Klik disini untuk membuat Laporan Pekerjaan Baru.</span>
                    </v-tooltip>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="listLaporans"
                  :items-per-page="15"
                  class="elevation-1 table-soft"
                >
                  <template v-slot:item.aksi="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="btn-icon-warning" v-on="on" fab x-small :to="'/repwork/upwfh/' + item.id">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Ubah</span>
                    </v-tooltip>

                    &nbsp;

                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="btn-icon-success"
                          :disabled="item.linkfile == null"
                          v-on="on"
                          fab
                          x-small
                          @click="goFileLink(item.linkfile)"
                        >
                          <v-icon>mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Lihat File Laporan</span>
                    </v-tooltip>

                    &nbsp;

                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="btn-icon-danger" v-on="on" fab x-small @click="delLaporan(item.id)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Hapus Laporan</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </base-material-card>
            </v-tab-item>

            <!-- TAB 2: REKAP (ADMIN) -->
            <v-tab-item>
              <base-material-card
                icon="mdi-clipboard-text"
                title="Rekap Data Laporan Pekerjaan"
                class="px-5 py-3 card-soft"
              >
              <br>
                <v-row class="align-center">
                  <v-col cols="12" sm="5" md="4">
                    <v-dialog
                      ref="SelDate"
                      v-model="menuSelDate"
                      :return-value.sync="txtDatein"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="txtDatein"
                          label="Pilih Tanggal"
                          prepend-inner-icon="mdi-calendar"
                          outlined
                          dense
                          readonly
                          v-on="on"
                          class="field"
                        />
                      </template>

                      <v-date-picker v-model="txtDatein">
                        <v-spacer />
                        <v-btn text color="primary" @click="menuSelDate = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.SelDate.save(txtDatein)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col cols="12" sm="3" md="2">
                    <v-btn class="btn-secondary" block rounded @click="feedingReportTable()">
                      <v-icon left>mdi-refresh</v-icon>
                      Show Data
                    </v-btn>
                  </v-col>

                  <v-col cols="12" sm="4" md="6" class="text-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="btn-primary" rounded v-on="on">
                          <export-excel
                            :disabled="listLaporansExcel.length <= 0"
                            :data="listLaporansExcel"
                            :name="excelfName"
                            type="xls"
                            :title="excelTitle"
                          >
                            Download Data
                            <v-icon right>mdi-download</v-icon>
                          </export-excel>
                        </v-btn>
                      </template>
                      <span v-if="listLaporansExcel.length > 0">Silakan Download Excel KLIK Disini.</span>
                      <span v-else>Silakan Refresh Data Terlebih dahulu.</span>
                    </v-tooltip>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers_report"
                  :items="listLaporansAll"
                  :items-per-page="15"
                  class="elevation-1 table-soft"
                />
              </base-material-card>
            </v-tab-item>
          </v-tabs-items>
        </base-material-tabs>
      </v-col>
    </v-row>

    <!-- Snackbar -->
    <v-snackbar v-model="toast.show" :timeout="toast.timeout">
      {{ toast.text }}
      <v-btn :color="toast.color" text @click="toast.show = false">Close</v-btn>
    </v-snackbar>

    <!-- Loading -->
    <v-dialog v-model="isLoading" fullscreen>
      <v-container fluid fill-height style="background-color: rgba(0, 0, 0, 0.8);">
        <v-layout justify-center align-center>
          <v-card width="70vW" class="pa-md-2 mx-lg-auto" outlined>
            <v-list-item three-line centered>
              <v-list-item-content>
                <div class="overline mb-4">Processing</div>
                <v-list-item-title class="headline mb-1">Please Wait....</v-list-item-title>
                <v-list-item-subtitle>
                  <v-progress-linear indeterminate color="amber darken-2"></v-progress-linear>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-layout>
      </v-container>
    </v-dialog>

    <!-- Delete confirm -->
    <v-dialog v-model="delConfirm" persistent max-width="350">
      <v-card class="card-soft">
        <v-card-title class="headline">Konfirmasi</v-card-title>
        <v-card-text>Apakah anda yakin ingin meng-HAPUS data tersebut?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text class="btn-muted" @click="delConfirm = false">Batal</v-btn>
          <v-btn class="btn-danger" @click="doDeleteLaporan()">Hapus</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import { deleteLaporanWFH, getListByMonth, getListByMonthAllPegawai } from "@/api/laporanwfh";
import { _GLOBAL } from "@/api/server";

export default {
  name: "LaporanDashboard",

  data: () => ({
    tab: 0,
    toast: { show: false, color: "green", text: "", timeout: 2000 },
    tabs: [{ text: "Data Laporan Pekerjaan", icon: "mdi-information" }],
    headers: [
      { text: "ID", align: "start", sortable: false, value: "id" },
      { text: "NIK", value: "UserNIK", align: "center", class: "subtitle-1" },
      { text: "Tanggal", value: "dateIN", align: "center", sortable: true, class: "subtitle-1" },
      { text: "Jabatan", value: "userpos", align: "center", sortable: true, class: "subtitle-1" },
      { text: "Laporan", value: "jobTask", align: "center", class: "subtitle-1" },
      { text: "Catatan", value: "notes", align: "center", class: "subtitle-1" },
      { text: "Aksi", value: "aksi", align: "center", class: "subtitle-1" },
    ],
    headers_report: [
      { text: "ID", align: "start", sortable: false, value: "id" },
      { text: "NIK", value: "UserNIK", align: "center", class: "subtitle-1" },
      { text: "Nama", value: "fullname", align: "center", class: "subtitle-1" },
      { text: "Tanggal", value: "dateIN", align: "center", sortable: true, class: "subtitle-1" },
      { text: "Jabatan", value: "userpos", align: "center", sortable: true, class: "subtitle-1" },
      { text: "Laporan", value: "jobTask", align: "center", class: "subtitle-1" },
      { text: "Catatan", value: "notes", align: "center", class: "subtitle-1" },
    ],
    isLoading: false,
    selectedMonth: new Date().toISOString().substr(0, 7),
    menuSelMonth: false,
    listLaporans: [],
    listLaporansAll: [],
    listLaporansExcel: [],
    delConfirm: false,
    idDel: 0,
    menuSelDate: false,
    txtDatein: moment().format("YYYY-MM-DD"),
    excelfName: "LaporanWFH_" + moment().format() + ".xls",
    excelTitle: "",
    dataUser: null,
    isAdmin: false,
  }),

  created() {
    const sUser = localStorage.getItem("user");
    this.dataUser = JSON.parse(sUser);
    this.isAdmin = this.dataUser?.role?.id === 1;

    if (this.isAdmin) {
      this.tabs = [
        { text: "Data Laporan Pekerjaan", icon: "mdi-information" },
        { text: "Rekap Laporan Pekerjaan Seluruh Pegawai", icon: "mdi-information" },
      ];
    }
  },

  mounted() {
    this.feedingTable();
  },

  methods: {
    goFileLink(uri) {
      window.open(uri, "_blank");
    },
    showAddForm() {
      this.$router.push("/repwork/crwfh");
    },
    feedingTable() {
      const user = this.dataUser;
      const month = moment(this.selectedMonth).format("YYYY-MM");
      this.isLoading = true;

      getListByMonth(user.nik, month)
        .then((response) => {
          const data = response.data || [];
          data.forEach((element) => {
            element["userpos"] = element.prefix + element.pos_name;

            if (element.url !== null) element["linkfile"] = _GLOBAL.URLBACKEND + element.url;
            else element["linkfile"] = null;

            if (!element.notes) element["notes"] = "-";

            if (moment(element.dateIN).isValid()) element["dateIN"] = moment(element.dateIN).format("DD MMM YYYY");
            else element["dateIN"] = "-";
          });

          this.listLaporans = data;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    delLaporan(id) {
      this.idDel = id;
      this.delConfirm = true;
    },
    doDeleteLaporan() {
      this.delConfirm = false;
      if (this.idDel == 0) return false;

      this.isLoading = true;
      deleteLaporanWFH(this.idDel)
        .then(() => {
          this.isLoading = false;
          this.feedingTable();
          this.toast = { show: true, color: "green", text: "Laporan berhasil terhapus.", timeout: 2000 };
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.toast = { show: true, color: "red", text: "Laporan GAGAL terhapus, silakan dicoba kembali.", timeout: 2000 };
        });
    },
    feedingReportTable() {
      const month = moment(this.txtDatein).format("YYYY-MM-DD");
      const smonth = moment(this.txtDatein).format("DD MMM YYYY");
      this.excelTitle = "DATA LAPORAN PEKERJAAN WFH " + smonth;

      this.isLoading = true;
      getListByMonthAllPegawai(month)
        .then((response) => {
          const data = response.data || [];
          const excel = [];

          data.forEach((element) => {
            element["userpos"] = element.prefix + element.pos_name;

            if (element.url !== null) element["linkfile"] = _GLOBAL.URLBACKEND + element.url;
            else element["linkfile"] = null;

            if (!element.notes) element["notes"] = "-";

            if (moment(element.dateIN).isValid()) element["dateIN"] = moment(element.dateIN).format("DD MMM YYYY");
            else element["dateIN"] = "-";

            excel.push({
              Tanggal: element["dateIN"],
              NIK: element["UserNIK"],
              Nama: element["fullname"],
              "Laporan Pekerjaan": element["jobTask"],
              Catatan: element["notes"],
              Jabatan: element["userpos"],
              LinkFile: element["linkfile"],
            });
          });

          this.listLaporansExcel = excel;
          this.listLaporansAll = data;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
/* Tone sama dengan login.vue */
.dash-page {
  position: relative;
  min-height: calc(100vh - 64px);
  overflow: hidden;
}

.dash-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.dash-gradient {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(1000px 650px at 15% 20%, rgba(245, 131, 43, 0.15), transparent 60%),
    radial-gradient(900px 650px at 85% 10%, rgba(31, 86, 48, 0.30), transparent 60%),
    linear-gradient(135deg, #1F5630 0%, #352F36 100%);
}

.dash-pattern {
  position: absolute;
  inset: 0;
  background-image: url("~@/assets/bpdp-icon-pack.svg");
  background-repeat: repeat;
  background-size: 200px;
  opacity: 0.06;
  filter: grayscale(100%);
  mix-blend-mode: overlay;
}

/* Ensure content above bg */
#panels > * {
  position: relative;
  z-index: 1;
}

/* Soft card/table rounding */
.card-soft {
  border-radius: 20px;
}

.table-soft {
  border-radius: 16px;
  overflow: hidden;
}

/* Fields */
.field :deep(.v-input__slot) {
  border-radius: 14px !important;
}

/* Buttons tone */
.btn-primary {
  background: #F5832B !important;
  color: #FFFFFF !important;
  box-shadow: 0 10px 22px rgba(245, 131, 43, 0.35);
}

.btn-secondary {
  background: transparent !important;
  border: 2px solid #1F5630 !important;   /* Green BPDP */
  color: #1F5630 !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.btn-secondary:hover {
  background: rgba(31,86,48,0.08) !important;
}

.btn-secondary-light {
  background: #FFFFFF !important;
  color: #1F5630 !important; /* hijau BPDP */
  border: 1px solid rgba(31, 86, 48, 0.45) !important;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

.btn-secondary-light:hover {
  border-color: rgba(31, 86, 48, 0.75) !important;
}

/* pastikan icon ikut warna text */
.btn-secondary-light .v-icon {
  color: #1F5630 !important;
}

.btn-muted {
  color: #1F5630 !important;
}

.btn-danger {
  background: #D32F2F !important;
  color: #FFFFFF !important;
}

/* Icon action buttons */
.btn-icon-warning {
  background: #F5832B !important;
  color: #fff !important;
}

.btn-icon-success {
  background: #1F5630 !important;
  color: #fff !important;
}

.btn-icon-danger {
  background: #D32F2F !important;
  color: #fff !important;
}
</style>